module.exports = __webpack_public_path__ + "static/img/img-sing-up-right.f73de6c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-sing-up-right.gif
// module id = 455
// module chunks = 2